declare global {
  interface Window {
    __ENV?: Record<string, string>
  }
}

import {zx} from 'shared/type'
import {doTry} from 'shared/promise'
import {z} from 'zod'
import {match, P} from 'ts-pattern'

const dynamicEnv = () => (typeof window !== 'undefined' ? window.__ENV : undefined)

/** Get all env vars from browser/server */
const allEnv = () =>
  dynamicEnv() ?? {
    NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL,
    NEXT_PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
    NEXT_PUBLIC_SUPABASE_STORAGE_KEY: process.env.NEXT_PUBLIC_SUPABASE_STORAGE_KEY,
    NEXT_PUBLIC_VERCEL_URL: process.env.NEXT_PUBLIC_VERCEL_URL,
    NEXT_PUBLIC_URL: process.env.NEXT_PUBLIC_URL,
    NEXT_PUBLIC_R2_URL: process.env.NEXT_PUBLIC_R2_URL,
    NEXT_PUBLIC_VIZ_URL: process.env.NEXT_PUBLIC_VIZ_URL,
    NEXT_PUBLIC_VIZ_R2_PARAM: process.env.NEXT_PUBLIC_VIZ_R2_PARAM,
    NEXT_PUBLIC_ENV_NAME: process.env.NEXT_PUBLIC_ENV_NAME,
    NEXT_PUBLIC_HELP_ASSET_URL: process.env.NEXT_PUBLIC_HELP_ASSET_URL,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_SERVICE_URL: process.env.NEXT_PUBLIC_SERVICE_URL,
    NEXT_PUBLIC_JOIN_URL: process.env.NEXT_PUBLIC_JOIN_URL,
    NEXT_PUBLIC_SELF_HOST: process.env.NEXT_PUBLIC_SELF_HOST,
    NEXT_PUBLIC_STRIPE_KEY: process.env.NEXT_PUBLIC_STRIPE_KEY,
    NEXT_PUBLIC_CRISP_WEBSITE_ID: process.env.NEXT_PUBLIC_CRISP_WEBSITE_ID
  }

export const zEnvVariablesPublic = z.object({
  NEXT_PUBLIC_SUPABASE_URL: z.string().min(1).default('https://127.0.0.1:5432'),
  NEXT_PUBLIC_SUPABASE_ANON_KEY: z.string().optional(),
  NEXT_PUBLIC_SUPABASE_STORAGE_KEY: z.string().optional(),
  NEXT_PUBLIC_VERCEL_URL: z.string().optional(),
  NEXT_PUBLIC_VERCEL_SCHEME: z.string().optional(),
  NEXT_PUBLIC_URL: z.string().min(1).default('http://localhost:3000'),
  NEXT_PUBLIC_R2_URL: z.string().optional(),
  NEXT_PUBLIC_VIZ_URL: z.string().optional(),
  NEXT_PUBLIC_VIZ_R2_PARAM: z.coerce.boolean().optional(),
  NEXT_PUBLIC_ENV_NAME: z.string().optional(),
  NEXT_PUBLIC_HELP_ASSET_URL: z.string().min(1).default('https://data.swiftcentre.org/help'),
  NEXT_PUBLIC_DISABLE_REALTIME: zx.nullish.bool,
  NEXT_PUBLIC_POSTHOG_KEY: z.string().optional(),
  NEXT_PUBLIC_SERVICE_URL: z.string().min(1).default('http://localhost:8080'),
  NEXT_PUBLIC_JOIN_URL: z.string().optional(),
  NEXT_PUBLIC_SELF_HOST: zx.nullish.bool,
  NEXT_PUBLIC_STRIPE_KEY: z.string().optional(),
  NEXT_PUBLIC_CRISP_WEBSITE_ID: z.string().optional()
})

const rawEnv = allEnv()
const envParsed = doTry(
  () => zEnvVariablesPublic.parse(rawEnv),
  e => {
    throw match(e)
      .with(P.instanceOf(z.ZodError), e => new Error(zx.fmtError(e)))
      .otherwise(e => e)
  }
)!

const URL =
  rawEnv.NEXT_PUBLIC_URL ??
  (envParsed.NEXT_PUBLIC_VERCEL_URL ?
    `${envParsed.NEXT_PUBLIC_VERCEL_SCHEME ?? 'https'}://${envParsed.NEXT_PUBLIC_VERCEL_URL}`
  : envParsed.NEXT_PUBLIC_URL)
export const env = {
  ...envParsed,
  URL,
  NEXT_PUBLIC_JOIN_URL: envParsed.NEXT_PUBLIC_JOIN_URL ?? `${URL}/join`
}
